import * as React from "react";
import { ThemePalette } from "../../../../theme/_Types";
import { Div } from "../../03-base/Div";
import { LoadingIndications, LoadingIndicator } from "../../05-atoms/LoadingIndicator";
import { LostAndFound } from "./LostAndFound";
import * as I18n from "../../../../utils/translations/I18n";
/**
 *
 * @param props
 */
export var LoadingData = function (props) {
    var _a, _b, _c, _d;
    return (React.createElement(Div, { className: "scl-h-text-align--center", theme: {
            padding: { "": { y: 3 }, "sm": { y: 4 } },
        } }, !!props.errorMessage ?
        React.createElement(LostAndFound, { title: "Oops!", description: props.errorMessage })
        : props.loading ? (React.createElement(React.Fragment, null,
            React.createElement(LoadingIndicator, { type: LoadingIndications.DEFAULT, theme: { palette: ThemePalette.BRAND_PRIMARY } }),
            React.createElement("h6", null, I18n.getText("mary.09-views.00-blocks.loadingdata.is-loading", "Loading data..")))) :
            !props.loading && props.init ?
                React.createElement(LostAndFound, { title: (_a = I18n.getText("mary.09-views.00-blocks.loadingdata.title--init", "Have we searched yet?")) !== null && _a !== void 0 ? _a : "", description: (_b = I18n.getText("mary.09-views.00-blocks.loadingdata.description--init", "Claude suggests to adjust the filter.")) !== null && _b !== void 0 ? _b : "" })
                : React.createElement(LostAndFound, { title: (_c = I18n.getText("mary.09-views.00-blocks.loadingdata.title", "No results!")) !== null && _c !== void 0 ? _c : "", description: (_d = I18n.getText("mary.09-views.00-blocks.loadingdata.description", "Claude thinks there is no data to display.")) !== null && _d !== void 0 ? _d : "" })));
};
